import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "todo-section" }
const _hoisted_2 = { class: "todo-header" }
const _hoisted_3 = { class: "todo-header-text" }
const _hoisted_4 = { class: "todo-element" }
const _hoisted_5 = { class: "todo-element-header" }
const _hoisted_6 = { class: "todo-element-header-icons" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]


import draggable from 'vuedraggable';

import { CategoryTask, Task } from '@/models/task';
import { useTodo, useModal } from '@/composables';
import { evaluateCategoryTask, evaluateRelevanceTask } from '@/utils/evaluatePropsTask';

interface Props {
  category: CategoryTask;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TodoGroup',
  props: {
    category: null
  },
  setup(__props: any) {

const props = __props as {
  category: CategoryTask;
};


const { setOpenModal } = useModal();
const {
  setTaskActive,
  getTasksTodoByCategory,
  updateMovedTask,
  updateCategoryTask,
  removeTask,
  clearAllTasksByCategory,
} = useTodo();

const listTasks = getTasksTodoByCategory(props.category);

const onDraggableChange = (payload: any) => {
  if (payload?.added?.element?.category) {
    updateCategoryTask(payload?.added?.element, props.category);
  }

  if (payload?.moved?.element) {
    updateMovedTask(payload?.moved, props.category);
  }
};

const onUpdateTask = (task: Task) => {
  setOpenModal(props.category, true);
  setTaskActive(task);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, _toDisplayString(props.category), 1),
        _createElementVNode("span", {
          class: _normalizeClass(_unref(evaluateCategoryTask)(props.category))
        }, _toDisplayString(_unref(listTasks)?.length), 3)
      ]),
      _createElementVNode("i", {
        class: "fa-solid fa-plus",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(setOpenModal)(props.category)))
      })
    ]),
    _createVNode(_unref(draggable), {
      class: "todo-list",
      modelValue: _unref(listTasks),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(listTasks) ? (listTasks).value = $event : null)),
      group: "people",
      "item-key": "id",
      onChange: onDraggableChange
    }, {
      item: _withCtx(({ element }) => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(_unref(evaluateRelevanceTask)(element.relevance))
            }, _toDisplayString(element.relevance), 3),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("i", {
                class: "fa-solid fa-pen-to-square",
                onClick: ($event: any) => (onUpdateTask(element))
              }, null, 8, _hoisted_7),
              _createElementVNode("i", {
                class: "fa-solid fa-trash",
                onClick: ($event: any) => (_unref(removeTask)(element))
              }, null, 8, _hoisted_8)
            ])
          ]),
          _createTextVNode(" " + _toDisplayString(element.title), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("p", {
      class: "clear-tasks",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(clearAllTasksByCategory)(props.category)))
    }, "Clear tasks")
  ]))
}
}

})